export default {
        getColor(color_string) {
            let rgb_color = 'none';
            if(color_string == 'green'){
                rgb_color = "rgba(24, 124, 24, 1.00)";
            }
            if(color_string == 'blue'){
                rgb_color = "rgba(49, 57, 150, 1.00)";
            }
            if(color_string == 'orange'){
                rgb_color = "rgba(199, 80, 0, 1.00)";
            }
            if(color_string == 'red'){
                rgb_color = "rgba(209, 0, 7, 1.00)";
            }

            if(color_string){
                return 'background-color: '+rgb_color+'; color: white;';
            }
            else{
                return '';
            }
        },
        getBackgroundColor(color_string) {
            let rgb_color = 'none';
            if(color_string == 'green'){
                rgb_color = "rgba(24, 124, 24, 0.2)";
            }
            if(color_string == 'blue'){
                rgb_color = "rgba(0, 112, 185, 0.2)";
            }
            if(color_string == 'orange'){
                rgb_color = "rgba(199, 80, 0, 0.2)";
            }
            if(color_string == 'red'){
                rgb_color = "rgba(209, 0, 7, 0.2)";
            }
            if(color_string == 'yellow'){
                rgb_color = "rgba(255, 185, 29, 0.2)";
            }
            if(color_string == 'gray'){
                rgb_color = "rgba(211, 211, 211, 0.5)";
            }
            if(color_string == 'teal'){
                rgb_color = "rgba(32, 129, 141, 0.2)";
            }
            if(color_string == 'pink'){
                rgb_color = "rgba(205, 50, 138, 0.2)";
            }
            if(color_string == 'purple'){
                rgb_color = "rgba(108, 88, 142, 0.2)";
            }
            if(color_string){
                return 'background-color: '+rgb_color+'!important; color: black!important; border: 1px solid black !important;';
            }
            else{
                return '';
            }
        },
        getBorderColor(color_string) {
            let rgb_color = 'none';
            if(color_string == 'green'){
                rgb_color = "rgba(24, 124, 24, 1.00)";
            }
            if(color_string == 'blue'){
                rgb_color = "rgba(49, 57, 150, 1.00)";
            }
            if(color_string == 'orange'){
                rgb_color = "rgba(199, 80, 0, 1.00)";
            }
            if(color_string == 'red'){
                rgb_color = "rgba(209, 0, 7, 1.00)";
            }
            if(color_string == 'gray'){
                rgb_color = "gray";
            }

            if(color_string){
                return rgb_color;
            }
            else{
                return '';
            }
        },

}